import { Check, Copy } from 'lucide-react'
import { Button } from '@/components/ds2'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'
import { trackBoxTruckUiInteraction } from '../utils/analytics'
import { DesignPasteButton } from './DesignPasteButton'

interface TemplateDesignCodeProps {
    html: string
    onPaste: (plainText: string, html: string) => boolean
}

/** The HTML tab: the design moves in and out as code without anyone having to read it. */
export const TemplateDesignCode = ({ html, onPaste }: TemplateDesignCodeProps) => {
    const { copiedKey, copy } = useCopyToClipboard({
        errorMessage: 'Could not copy the design code',
        onCopied: () => trackBoxTruckUiInteraction('template_design_code_copied'),
    })
    const copied = copiedKey === 'design-code'

    return (
        <div className="flex flex-col gap-3 rounded-2xl bg-surface-secondary p-4">
            <div className="flex flex-col gap-1">
                <p className="text-sm font-medium text-foreground">Your email design is stored as code</p>
                <p className="text-xs text-foreground-muted">
                    Copy it to keep a backup or to share it. To use a design made by an AI or a designer, copy their code and paste it here — you will see a
                    preview before anything is saved.
                </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
                <Button variant="secondary" size="sm" prefix={copied ? <Check size={16} /> : <Copy size={16} />} onClick={() => void copy(html, 'design-code')}>
                    {copied ? 'Copied' : 'Copy design code'}
                </Button>
                <DesignPasteButton label="Paste design code" onPaste={onPaste} />
            </div>
        </div>
    )
}
